import { useEffect, useState } from "react";
import { MotionConfig } from "framer-motion";
import { SignalNav } from "@/components/signal/SignalNav";
import { SignalHero } from "@/components/signal/SignalHero";
import { SignalObject } from "@/components/signal/SignalObject";
import { SignalStandalone } from "@/components/signal/SignalStandalone";
import { SignalReveal } from "@/components/signal/SignalReveal";
import { SignalVoices } from "@/components/signal/SignalVoices";
import { SignalConnected } from "@/components/signal/SignalConnected";
import { SignalTransmission } from "@/components/signal/SignalTransmission";
import { SignalFooter } from "@/components/signal/SignalFooter";
import "@/components/signal/signal.css";

// Approved Preview homepage, shared by the protected / and /signal routes.
export default function Signal() {
  const [finish, setFinish] = useState("obsidian_black");
  useEffect(() => { document.title = "Pulse One — Ivory Pulse"; }, []);
  return (
    <MotionConfig reducedMotion="user">
      <div className="signal-site" data-testid="signal-page">
        <SignalNav />
        <main id="signal-main" data-testid="signal-main">
          <SignalHero />
          <SignalObject />
          <SignalStandalone />
          <SignalReveal finish={finish} onFinishChange={setFinish} />
          <SignalVoices />
          <SignalConnected />
          <SignalTransmission finish={finish} onFinishChange={setFinish} />
        </main>
        <SignalFooter />
      </div>
    </MotionConfig>
  );
}